var map = {
	"./22/DOGE_USD_70.json": 62062,
	"./23/DOGE_USD_70.json": 96545,
	"./24/DOGE_USD_70.json": 72004,
	"./26/DOGE_USD_70.json": 72010,
	"./28/DOGE_USD_70.json": 19936,
	"./29/DOGE_USD_70.json": 72579,
	"./30/DOGE_USD_70.json": 71101,
	"./31/DOGE_USD_70.json": 67770,
	"./32/DOGE_USD_70.json": 39207,
	"./33/DOGE_USD_70.json": 28500,
	"./34/DOGE_USD_70.json": 55633,
	"./35/DOGE_USD_70.json": 86302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35805;